/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// ====================== 资产定义管理 ======================

exports.getMerchtDevcDefList = function (data, callback) {// 获取 - 资产定义列表
    api.post('/mercht/devc/def/list/get')
        .data(data)
        .done(callback)
        .go();
};
//
exports.getMerchtDevcDefInfo = function (params, callback) {// 获取 - 资产定义信息
    api.get('/mercht/devc/def/get')
        .params(params)
        .done(callback)
        .go();
};
//
exports.getMerchtDevcDefInfoByInnerCode = function (params, callback) {// 获取资产定义信息-根据资产编号
    api.get('/mercht/devc/def/get/by/innerCode')
        .params(params)
        .done(callback)
        .go();
};
//
exports.getMerchtDevcDefInfoByUK = function (data, callback) {// 获取资产定义信息-根据唯一键
    api.post('/mercht/devc/def/get/by/uk')
        .data(data)
        .done(callback)
        .go();
};
// 系统生成定义编码
exports.getDefInnerCodeByAssetType = function (params, callback) {// 系统生成定义编码
    api.get('/mercht/devc/def/innerCode/get/by/assetType')
        .params(params)
        .done(callback)
        .go();
};
//
exports.saveMerchtDevcDef = function (data, callback) {// 保存 - 资产定义
    api.post('/mercht/devc/def/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 资产定义设置安装时完成组装
exports.updateMerchtDevcDefAsmblWhileSetup = function (data, callback) {// 资产定义设置安装时完成组装
    api.post('/mercht/devc/def/asmblWhileSetup/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 资产定义财务标准化
exports.updateMerchtDevcDefFiscalInfo = function (data, callback) {// 资产定义财务标准化
    api.post('/mercht/devc/def/fiscal/update/do')
        .data(data)
        .done(callback)
        .go();
};
// 获取资产定义最近一次审核岗
exports.getDevcDefLastAuditInfo = function (data, callback) {// 获取资产定义最近一次审核岗
    api.post('/mercht/devc/def/last/audit/info/get')
        .data(data)
        .done(callback)
        .go();
};
// 申请定义
exports.doApplyMerchtDevcDef = function (data, callback) {// 申请定义
    api.post('/mercht/devc/def/apply/do')
        .data(data)
        .done(callback)
        .go();
};
// 审核定义
exports.doAuditMerchtDevcDef = function (data, callback) {// 审核定义
    api.post('/mercht/devc/def/audit/do')
        .data(data)
        .done(callback)
        .go();
};
// 定义财务审核
exports.doFiscalAuditMerchtDevcDef = function (data, callback) {// 定义财务审核
    api.post('/mercht/devc/def/fiscal/audit/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.updateMerchtDevcDefAssetKind = function (data, callback) {// 设置财务类别
    api.post('/mercht/devc/def/asset/kind/update/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.doMerchtDevcDefRelComDevcDefItem = function (data, callback) {// 资产定义 - 关联资产型号
    api.post('/mercht/devc/def/rel/com/devc/def/item/do')
        .data(data)
        .done(callback)
        .go();
};
exports.doSaveMerchtDevcDefRel = function (data, callback) {// 资产定义 - 关联组装件
    api.post('/mercht/devc/def/rel/acc/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 获取资产定义已关联组装件列表
exports.getAsmblAccDefList = function (data, callback) {
    api.post('/mercht/devc/acc/asmbl/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteMerchtDevcDefRel = function (data, callback) {
    api.post('/mercht/devc/def/rel/acc/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// 资产定义转移（打标记合并）
exports.doMerchtDevcDefTransfer = function (data, callback) {
    api.post('/mercht/devc/def/transfer/do')
        .data(data)
        .done(callback)
        .go();
};
// 资产定义转移执行
exports.doMerchtDevcDefTransferExecute = function (data, callback) {
    api.post('/mercht/devc/def/transfer/execute/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.deleteMerchtDevcDef = function (data, callback) {// 删除 - 资产定义
    api.post('/mercht/devc/def/delete/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.validateDevcDefImpModel = function (data, callback) {// 资产定义导入验证
    api.post('/mercht/devc/def/imp/model/validate')
        .data(data)
        .done(callback)
        .go();
};
//
exports.doDevcDefImpModelImport = function (data, callback) {// 资产定义导入
    api.post('/mercht/devc/def/imp/model/import/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.devcDefImpModelForExport = function (data, callback) {// 资产定义导出当前导入数据
    api.post('/mercht/devc/del/imp/model/for/export/url')
        .data(data)
        .done(callback)
        .go();
};
//
exports.lowCostDefImpModelForExport = function (data, callback) {// 耗材定义导出当前导入数据
    api.post('/mercht/devc/low/cost/del/imp/model/for/export/url')
        .data(data)
        .done(callback)
        .go();
};
// ====================== 资产手册 ======================
exports.getMerchtDevcManualPagedList = function (data, callback) {// 获取 - 资产手册分页列表
    api.post('/mercht/devc/manual/paged/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getMerchtDevcManuals = function (params, callback) {// 获取 - 资产手册列表
    api.get('/mercht/devc/manual/list/get')
        .params(params)
        .done(callback)
        .go();
};
exports.getMerchtDevcManualFileNames = function (data, callback) {// 获取 - 资产手册名称列表
    api.post('/mercht/devc/manual/fileName/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getMerchtDevcManualDetail = function (params, callback) {// 获取 - 资产手册信息
    api.get('/mercht/devc/manual/detail/get')
        .params(params)
        .done(callback)
        .go();
};

exports.saveMerchtDevcManuals = function (data, callback) {// 批量保存资产手册
    api.post('/mercht/devc/manual/save/do')
        .data(data)
        .done(callback)
        .go();
};
exports.updateMerchtDevcManual = function (data, callback) {// 编辑资产手册
    api.post('/mercht/devc/manual/update/do')
        .data(data)
        .done(callback)
        .go();
};
exports.doMerchtDevcManualRelDef = function (data, callback) {// 资产手册关联资产定义
    api.post('/mercht/devc/manual/rel/def/do')
        .data(data)
        .done(callback)
        .go();
};
exports.deleteMerchtDevcManual = function (data, callback) {// 删除资产手册
    api.post('/mercht/devc/manual/delete/do')
        .data(data)
        .done(callback)
        .go();
};
// ============================== 商户资产手册关联 =======================================
//
exports.getMerchtDevcManualRelDevcDefIds = function (params, callback) {// 获取已关联手册的定义的ids
    api.get('/mercht/devc/manual/rel/devcDefIds/get')
        .params(params)
        .done(callback)
        .go();
};

// 根据资产定义id查询对应的组装件定义id
exports.getMerchtDevcAccAsmblRelAccDefIdByDevcDefId = function (params, callback) {
    api.get('/mercht/devc/acc/asmble/rel/accDefId/get/by/devcDefId')
        .params(params)
        .done(callback)
        .go();
};

// 资产定义设置供应商
exports.updateMerchtDevcDefVendor = function (params, callback) {
    api.post('/mercht/devc/def/vendor/update/do')
        .data(params)
        .done(callback)
        .go();
};

// ========================= 商户资产定义审核记录 ====================
exports.getMerchtDevcDefAuditRecList = function (params, callback) {// 获取 - 商户资产定义审核记录列表
    api.get('/mercht/devc/def/audit/rec/list/get')
        .params(params)
        .done(callback)
        .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcDef.js
// module id = 36
// module chunks = 0